
    import {Component, Prop, Vue} from 'vue-property-decorator';
    import {Question} from '@/lib/Question';
    import SuggestionChoices from './SuggestionChoices';

    @Component({
        components: {
            SuggestionChoices
        }
    })
    export default class NumberQuestion extends Vue {
        @Prop() public question?: Question;
        mounted(){
            if(this.question!.currentResponse!.value){
                this.currencyFormat();
            }

        }

        public updateWithSuggestion(choice) {
            this.question!.currentResponse!.value = choice.value;
            this.currencyFormat();
            this.question.changedEvent.emit('');
            this.question.validate();
            setTimeout(() => {
                this.$emit('chosen');
            }, 500);
        }
        public currencyFormat() {
            this.question!.currentResponse!.value =  NumberQuestion.transformBack(NumberQuestion.transform(this.question!.currentResponse!.value));
        }

        public static transform(numberString: string){
          return numberString.replace(/\s/g, '');
        }

        public static transformBack(numberString: string){
          const match = numberString.match(/(\d+?)(?=(\d{3})+(?!\d)|$)/g);
          if(match){
            numberString = match.join(' ');
          }
          return numberString;
        }

    }
